import { SESSION_BLOCKING_REASONS, SESSION_PHASES } from "./constants";

const SESSION_EXPIRY_TO_BLOCKING_REASON = Object.freeze({
  missing_refresh_token: SESSION_BLOCKING_REASONS.missingRefreshToken,
  login_required: SESSION_BLOCKING_REASONS.loginRequired,
  consent_required: SESSION_BLOCKING_REASONS.consentRequired,
  interaction_required: SESSION_BLOCKING_REASONS.interactionRequired,
  invalid_grant: SESSION_BLOCKING_REASONS.invalidGrant,
  session_expired: SESSION_BLOCKING_REASONS.sessionExpired,
});

export const mapSessionExpiryReasonToBlockingReason = (reason) =>
  SESSION_EXPIRY_TO_BLOCKING_REASON[reason] || SESSION_BLOCKING_REASONS.unknown;

export const isSessionRecoveryPhase = (phase) =>
  phase === SESSION_PHASES.recoveryRequired;

export const isSessionAccessBlocked = (state) =>
  isSessionRecoveryPhase(state?.phase);
